import { RepeatNode, RepeatNodePrivate } from "./repeat-node";
/**
 * Private part of BaseView
 * @class BaseViewPrivate
 * @extends RepeatNodePrivate
 */
export class BaseViewPrivate extends RepeatNodePrivate {
    constructor() {
        super();
        this.$seal();
    }
}
/**
 * Base class of default views
 * @class BaseView
 * @extends RepeatNode
 * @implements IModel
 */
export class BaseView extends RepeatNode {
    constructor($1) {
        super($1 || new BaseViewPrivate);
        const $ = this.$;
        $.addHandler = (id, item) => {
            this.createChild(id, item);
        };
        $.removeHandler = (id, item) => {
            this.destroyChild(id, item);
        };
        this.$seal();
    }
    /**
     * Handle ready event
     */
    $ready() {
        const $ = this.$;
        this.model.listener.onAdd($.addHandler);
        this.model.listener.onRemove($.removeHandler);
        super.$ready();
    }
    /**
     * Handles destroy event
     */
    $destroy() {
        const $ = this.$;
        this.model.listener.offAdd($.addHandler);
        this.model.listener.offRemove($.removeHandler);
        super.$destroy();
    }
}
